export default "__VITE_ASSET__CAqQln_X__"